<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 bottom-0 h-0.5" [mode]="'indeterminate'"></mat-progress-bar>
}

@if (!loading) {
  <div class="flex flex-col -m-6">
    <div
      class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">
        {{ 'services.dialog.multiTaskEdit.title' | transloco: {number: $safeNavigationMigration(data.multiTaskEditData.effectiveTaskId?.length)} }}
      </div>
    </div>
    <div class="w-full flex flex-col p-2">
      <form class="flex flex-col w-full mb-4" [formGroup]="taskForm">
        <div class="flex-col w-full p-4 items-center">
          <!-- Planning Area -->
          <div class="flex items-center w-full pt-3">
            <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.planningArea' | transloco }}</mat-label>
            <mat-form-field class="flex-1 w-32">
              <mat-select formControlName="planningArea">
                @for (planningArea of data.multiTaskEditData.planningArea.options ?? []; track planningArea) {
                  <mat-option [value]="planningArea.code">
                    {{ planningArea.value | localize }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.planningArea"
              (change)="changeChecks($event.checked, 'planningArea')">
              <span [ngClass]="{ 'text-red-500': !checks.planningArea, 'text-green-500': checks.planningArea }">
                {{ data.multiTaskEditData?.planningArea?.diffNumber }}
              </span>
            </mat-checkbox>
          </div>
          <!-- Start date -->
          @if (data.multiTaskEditData?.scheduled_from_date) {
            <div class="flex items-center w-full">
              <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.date' | transloco}}</mat-label>
              <mat-form-field class="flex-1 w-32" [disabled]="!checks.scheduled_from_date">
                <input matInput formControlName="scheduled_from_date" [min]="today"
                  [max]="taskForm.get('scheduled_to_date').value ?? data.service.dateTo" [matDatepicker]="datepicker" [matDatepickerFilter]="myDateFilter"
                  (click)="openDatepickerOnClick(datepicker)" required
                  [placeholder]="'startDatePlaceholder' | transloco" readonly>
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker [startView]="remote ? 'multi-year' : 'month'"></mat-datepicker>
                </mat-form-field>
                <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.scheduled_from_date"
                  (change)="changeChecks($event.checked, 'scheduled_from_date')">
                  <span [ngClass]="{'text-red-500': !checks.scheduled_from_date, 'text-green-500': checks.scheduled_from_date}">
                    {{ data.multiTaskEditData?.scheduled_from_date?.diffNumber }}
                  </span>
                </mat-checkbox>
              </div>
            }
            <!-- End date -->
            @if (data.multiTaskEditData?.scheduled_to_date) {
              <div class="flex items-center w-full">
                <mat-label class="flex-initial w-16 mb-5 mr-6">
                  {{ 'services.dialog.multiTaskEdit.endDate' | transloco }}
                </mat-label>
                <mat-form-field class="flex-1 w-32" [disabled]="!checks.scheduled_to_date">
                  <input matInput formControlName="scheduled_to_date" [min]="taskForm.get('scheduled_from_date').value ?? today"
                    [max]="data.service.dateTo" [matDatepicker]="datepicker" [matDatepickerFilter]="myDateFilter"
                    (click)="openDatepickerOnClick(datepicker)" required
                    [placeholder]="'endDatePlaceholder' | transloco" readonly>
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker [startView]="remote ? 'multi-year' : 'month'"></mat-datepicker>
                  </mat-form-field>
                  <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.scheduled_to_date"
                    (change)="changeChecks($event.checked, 'scheduled_to_date')">
                    <span [ngClass]="{'text-red-500': !checks.scheduled_to_date, 'text-green-500': checks.scheduled_to_date}">
                      {{ data.multiTaskEditData?.scheduled_to_date?.diffNumber }}
                    </span>
                  </mat-checkbox>
                </div>
              }
              @if (!data.multiTaskEditData?.scheduled_from_date && !data.multiTaskEditData?.scheduled_to_date) {
                <div class="flex items-center w-full pt-3 pb-4">
                  <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.dates' | transloco }}</mat-label>
                  <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                    {{ 'services.dialog.multiTaskEdit.disabledDates' | transloco }}
                  </mat-label>
                </div>
              }
              <!-- Workday -->
              @if (data.multiTaskEditData?.workDayType) {
                <div class="flex items-center w-full pt-3">
                  <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.workday' | transloco }}</mat-label>
                  <mat-form-field class="flex-1 w-32">
                    <mat-select formControlName="workDayTypeOid">
                      <mat-option [value]="">
                        {{ 'noSelection' | transloco }}
                      </mat-option>
                      @for (workday of data.multiTaskEditData.workDayType.options ?? []; track workday) {
                        <mat-option [value]="workday.code">
                          {{ workday.value | localize }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.workDayTypeOid"
                    (change)="changeChecks($event.checked, 'workDayTypeOid')">
                    <span [ngClass]="{ 'text-red-500': !checks.workDayTypeOid, 'text-green-500': checks.workDayTypeOid }">
                      {{ data.multiTaskEditData?.workDayType?.diffNumber }}
                    </span>
                  </mat-checkbox>
                </div>
              }
              @if (!data.multiTaskEditData?.workDayType) {
                <div class="flex items-center w-full pt-3 pb-4">
                  <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.workday' | transloco }}</mat-label>
                  <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                    {{ 'services.dialog.multiTaskEdit.disabledWorkday' | transloco }}
                  </mat-label>
                </div>
              }
              @if (data.multiTaskEditData?.scheduled_to_time && data.multiTaskEditData?.scheduled_from_time) {
                <div class="flex flex-col lg:flex-row lg:gap-4 2xl:gap-16">
                  <!-- Start Time -->
                  <div class="flex items-center w-full">
                    <mat-label class="flex-initial w-16 mr-6">{{ 'services.dialog.multiTaskEdit.timeFrom' | transloco }}
                    </mat-label>
                    <div class="flex-1 w-32">
                      <timepicker-autofill-component class="flex justify-center" [control]="taskForm.controls['scheduled_from_time']" [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'">
                      </timepicker-autofill-component>
                    </div>
                    <mat-checkbox class="flex-initial w-8 mx-2" [checked]="checks.scheduled_from_time"
                      (change)="changeChecks($event.checked, 'scheduled_from_time')">
                      <span [ngClass]="{'text-red-500': !checks.scheduled_from_time, 'text-green-500': checks.scheduled_from_time}">
                        {{ data.multiTaskEditData?.scheduled_from_time?.diffNumber }}
                      </span>
                    </mat-checkbox>
                  </div>
                  <!-- End Time -->
                  <div class="flex items-center w-full">
                    <mat-label class="flex-initial w-16 mr-6">{{ 'services.dialog.multiTaskEdit.timeTo' | transloco }}</mat-label>
                    <div class="flex-1 w-32">
                      <timepicker-autofill-component class="flex justify-center" [control]="taskForm.controls['scheduled_to_time']" [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'">
                      </timepicker-autofill-component>
                    </div>
                    <mat-checkbox class="flex-initial w-8 mx-2" [checked]="checks.scheduled_to_time"
                      (change)="changeChecks($event.checked, 'scheduled_to_time')">
                      <span [ngClass]="{'text-red-500': !checks.scheduled_to_time, 'text-green-500': checks.scheduled_to_time}">
                        {{ data.multiTaskEditData?.scheduled_to_time?.diffNumber }}
                      </span>
                    </mat-checkbox>
                  </div>
                </div>
              }
              <!-- Si hay jornada partida añadimos dos timepickers más-->
              @if (data.multiTaskEditData?.scheduled_from_time2 && data.multiTaskEditData?.scheduled_to_time2) {
                <div class="flex flex-col lg:flex-row lg:gap-4 2xl:gap-16">
                  <!-- Start Time -->
                  <div class="flex items-center w-full">
                    <mat-label class="flex-initial w-16 mr-6">
                      {{ 'services.dialog.multiTaskEdit.timeFrom2' | transloco }}
                    </mat-label>
                    <div class="flex-1 w-32">
                      <timepicker-autofill-component class="flex justify-center" [control]="taskForm.controls['scheduled_from_time2']" [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'">
                      </timepicker-autofill-component>
                    </div>
                    <mat-checkbox class="flex-initial w-8 mx-2" [checked]="checks.scheduled_from_time2"
                      (change)="changeChecks($event.checked, 'scheduled_from_time2')">
                      <span [ngClass]="{'text-red-500': !checks.scheduled_from_time2, 'text-green-500': checks.scheduled_from_time2}">
                        {{ data.multiTaskEditData?.scheduled_from_time2?.diffNumber }}
                      </span>
                    </mat-checkbox>
                  </div>
                  <!-- End Time -->
                  <div class="flex items-center w-full">
                    <mat-label class="flex-initial w-16 mr-6">{{ 'services.dialog.multiTaskEdit.timeTo2' | transloco }}
                    </mat-label>
                    <div class="flex-1 w-32">
                      <timepicker-autofill-component class="flex justify-center" [control]="taskForm.controls['scheduled_to_time2']" [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'">
                      </timepicker-autofill-component>
                    </div>
                    <mat-checkbox class="flex-initial w-8 mx-2" [checked]="checks.scheduled_to_time2"
                      (change)="changeChecks($event.checked, 'scheduled_to_time2')">
                      <span [ngClass]="{'text-red-500': !checks.scheduled_to_time2, 'text-green-500': checks.scheduled_to_time2}">
                        {{ data.multiTaskEditData?.scheduled_to_time2?.diffNumber }}
                      </span>
                    </mat-checkbox>
                  </div>
                </div>
              }
              @if (!data.multiTaskEditData?.scheduled_to_time2 && !data.multiTaskEditData?.scheduled_from_time2 && !data.multiTaskEditData?.scheduled_to_time && !data.multiTaskEditData?.scheduled_from_time) {
                <div class="flex items-center w-full pt-3 pb-4">
                  <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.schedule' | transloco }}</mat-label>
                  <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                    {{ 'services.dialog.multiTaskEdit.disabledTime' | transloco }}
                  </mat-label>
                </div>
              }
              @if (isTaskMoreThan8h) {
                <div class="w-full px-4 pb-4 text-gray-400">
                  * {{ 'taskMoreThan8h' | transloco }}
                </div>
              }
              @if (isTaskEndsNextDay) {
                <div class="w-full px-4 pb-4 text-gray-400">
                  * {{ 'taskEndsNextDay' | transloco }}
                </div>
              }
              <!-- User -->
              @if (data.multiTaskEditData?.user) {
                <div class="flex items-center w-full pt-3">
                  <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.user' | transloco }}</mat-label>
                  <mat-form-field class="flex-1 w-32">
                    <mat-select formControlName="userId">
                      <mat-option>
                        {{ 'emptyOption' | transloco | uppercase }}
                      </mat-option>
                      @for (user of data.multiTaskEditData.user?.options ?? []; track user) {
                        <mat-option [value]="user.code">
                          {{ user.value | localize }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.userId"
                    (change)="changeChecks($event.checked, 'userId')">
                    <span [ngClass]="{'text-red-500': !checks.userId, 'text-green-500': checks.userId}">
                      {{ data.multiTaskEditData?.user?.diffNumber }}
                    </span>
                  </mat-checkbox>
                </div>
              }
              @if (!data.multiTaskEditData?.user) {
                <div class="flex items-center w-full pt-3 pb-4">
                  <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.user' | transloco }}</mat-label>
                  <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                    {{ 'services.dialog.multiTaskEdit.disabledUser' | transloco }}
                  </mat-label>
                </div>
              }
              <!-- Zombie -->
              @if (!data.service.generateUsernamesManually) {
                @if (data.multiTaskEditData?.zombie) {
                  <div class="flex items-center w-full">
                    <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.zombie' | transloco }}</mat-label>
                    <mat-form-field class="flex-1 w-32">
                      <mat-select formControlName="zombieNumber">
                        <mat-option value="0">
                          {{ 'emptyOption' | transloco | uppercase }}
                        </mat-option>
                        @for (zombie of data.multiTaskEditData.zombie?.options ?? []; track zombie) {
                          <mat-option [value]="zombie.code">
                            {{ zombie.value | localize }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.zombieNumber"
                      (change)="changeChecks($event.checked, 'zombieNumber')">
                      <span [ngClass]="{'text-red-500': !checks.zombieNumber, 'text-green-500': checks.zombieNumber}">
                        {{ data.multiTaskEditData?.zombie?.diffNumber }}
                      </span>
                    </mat-checkbox>
                  </div>
                } @else {
                  <div class="flex items-center w-full pt-3 pb-4">
                    <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.zombie' | transloco }}</mat-label>
                    <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                      {{ 'services.dialog.multiTaskEdit.disabledZombie' | transloco }}
                    </mat-label>
                  </div>
                }
                @if (data.multiTaskEditData?.user && data.multiTaskEditData?.zombie) {
                  @if (selectedZombie && selectedUser && selectedZombie.zombieNumber !== selectedUser.zombieNumber && selectedUser.userId && selectedZombie.zombieNumber > 0) {
                    <mat-checkbox
                      class="mt-2 mb-4 mx-4" [checked]="changeUserZombieLink" (change)="changeUserZombieCheck($event.checked)">
                      {{ 'changeZombieUserLink' | transloco }}
                    </mat-checkbox>
                  }
                }
              }
              <!-- Address -->
              @if (visibleLocation) {
                <div class="flex items-center w-full">
                  <mat-label class="flex-initial w-16 mb-5 mr-6">{{ 'services.dialog.multiTaskEdit.location' | transloco }}</mat-label>
                  <mat-form-field class="flex-1 w-32">
                    <input matInput formControlName="location" [matAutocomplete]="acAddress">
                    <mat-autocomplete autoActiveFirstOption #acAddress="matAutocomplete"
                      [displayWith]="displayAddress">
                      @if (addressOptions?.length === 0) {
                        <mat-option disabled>
                          {{ 'addressNotFound' | transloco }}
                        </mat-option>
                      }
                      @for (option of addressOptions; track option) {
                        <mat-option [value]="option">
                          {{ option.name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <button mat-icon-button (click)="clearAddress()">
                      <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                    </button>
                  </mat-form-field>
                  <mat-checkbox class="flex-initial w-8 mb-5 mx-2" [checked]="checks.location"
                    (change)="changeChecks($event.checked, 'location')">
                    <span
                      [ngClass]="{'text-red-500': !checks.location, 'text-green-500': checks.location}">{{
                    data.multiTaskEditData?.address?.diffNumber }}</span>
                  </mat-checkbox>
                </div>
              }
              @if (!visibleLocation) {
                <div class="flex items-center w-full">
                  <mat-label class="flex-initial w-16">{{ 'services.dialog.multiTaskEdit.location' | transloco }}</mat-label>
                  <mat-label class="flex-auto w-64 items-center text-gray-400 ml-8">
                    {{ 'services.dialog.multiTaskEdit.disabledLocation' | transloco }}
                  </mat-label>
                </div>
              }
            </div>
          </form>
          <div class="flex flex-row justify-end pt-4">
            <button mat-flat-button class="mr-8" color="warn" (click)="closeDialog()">
              {{ 'cancel' | transloco }}
            </button>
            <button mat-flat-button class="mr-8" color="primary" (click)="updateTasks()">
              {{ 'services.dialog.multiTaskEdit.confirm' | transloco }}
            </button>
          </div>
        </div>
      </div>
    }